var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": "Activity Logs",
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeDialog
    },
    model: {
      value: _vm.isLogModalOpen,
      callback: function callback($$v) {
        _vm.isLogModalOpen = $$v;
      },
      expression: "isLogModalOpen"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-4"
  }, [_c('div', {
    staticClass: "d-flex gap-3"
  }, [_c('date-picker', {
    attrs: {
      "type": "date",
      "value-type": "YYYY-MM-DD",
      "format": "MM/DD/YYYY",
      "placeholder": "Filter by Date",
      "size": "sm"
    },
    on: {
      "change": _vm.triggerSearch
    },
    model: {
      value: _vm.filters.switched_date,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "switched_date", $$v);
      },
      expression: "filters.switched_date"
    }
  })], 1)]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rep ID")]), _c('th', [_vm._v("Rep Name")]), _c('th', [_vm._v(_vm._s(_vm.logName))]), _c('th', [_vm._v("Date/Time")]), _c('th', [_vm._v("Device Info")])])]), _c('tbody', [_vm._l(_vm.logs, function (log, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(log.agent.agent_id))]), _c('td', [_vm._v(_vm._s(log.agent.rep_full_name))]), _c('td', [_vm._v(_vm._s(log[_vm.logType][_vm.logNameData]))]), _c('td', [_vm._v(_vm._s(log.switched_date) + " " + _vm._s(log.switched_time))]), log.device != null || log.device != undefined ? _c('td', [_c('p', [_vm._v(_vm._s(log.device.device))]), _c('p', [_vm._v(_vm._s(log.device.ip_address))])]) : _c('td', [_vm._v("-")])]);
  }), _vm.logs.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" No logs found. ")])]) : _vm._e()], 2)])]), _c('Pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filtersWithUserId,
      "customSearchEvent": 'searchEvent-modal-logs'
    },
    on: {
      "update:rows": _vm.handleLogData
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }